import { render, staticRenderFns } from "./application-feature-settings.vue?vue&type=template&id=2206401a&scoped=true"
import script from "./application-feature-settings.vue?vue&type=script&lang=js"
export * from "./application-feature-settings.vue?vue&type=script&lang=js"
import style0 from "./application-feature-settings.vue?vue&type=style&index=0&id=2206401a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2206401a",
  null
  
)

export default component.exports